/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Karol Pawlak <kpa@giap.pl>, September 2021
 */
/* flow-disable */

import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { Grid, Row, Col } from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import PaperTile from '../../../components/PaperTile/PaperTile';
import PaperHeader from '../../../components/PaperHeader/PaperHeader';
import { layoutColorStyle, headerStyle, getThemeFromLocalStorage } from '../../../components/utils/utils';
import { getDistrictForUser, replaceMultipleSpaces } from '../../../lib/utils';
import { fetchDistrictServices } from '../../../actions/district';
import { adminEndpoint, adminRole } from '../../../../src/config';

import s from '../Admin.css';

const btnStyle = {
  width: '100%',
};

class ServiceCards extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    districts: PropTypes.object,
  };

  state = {
    selected_district: null,
    editMode: null,
    filter_text: '',
    service_filter_text: '',
    all_services: [],
    colors: 'normal',
    sourceStyle: layoutColorStyle,
    style: {},
  };

  componentDidMount = () => {
    this.fetchDistrict();
    this.fetchAllServices();
    const colors = getThemeFromLocalStorage();
    let sourceStyle = layoutColorStyle;
    let style = {
      color: sourceStyle[colors].color,
      display: 'block',
    };
    if (colors !== 'normal') {
      sourceStyle = headerStyle;
      style = {
        color: sourceStyle[colors].color,
        backgroundColor: sourceStyle[colors].backgroundColor,
        display: 'block',
      };
    }
    this.setState({ colors, sourceStyle, style });
  }

  async fetchDistrict() {
    if (this.props.isDistrictAdmin) {
      const selectedDistrict = await getDistrictForUser(this.props.user.ID);
      this.setState({ selected_district: selectedDistrict });
    } else {
      this.setState({ selected_district: null });
    }
  }

  async fetchAllServices() {
    if (!this.props.isDistrictAdmin) {
      const url = `${process.env.API_URL}/eservices/allservices/`;
      await fetch(url)
        .then(r => r.json())
        .then(resp => {
          this.setState({ all_services: resp });
        });
    }
  }


  districtFilterChange = (e) => {
    // zamiana kilku spacji na jedną
    const value = replaceMultipleSpaces(e.target.value);
    this.setState({ filter_text: value });
  };

  serviceFilterChange = (e) => {
    // zamiana kilku spacji na jedną
    const value = replaceMultipleSpaces(e.target.value);
    this.setState({ service_filter_text: value });
  };

  editModeChange = (editMode) => {
    this.setState({ editMode, selected_district: null });
  };

  onClick = (item) => {
    const prefix = this.props.districts[item].prefix;
    this.setState({ selected_district: prefix });
  };

  renderPaperTiles = () => {
    return (
      <div>
        {this.state.selected_district ? this.props.districts[this.state.selected_district].services.map(
          (item, i) => {
            if (this.props.eservices[item].title.toLowerCase().includes(this.state.service_filter_text.toLowerCase())) {
              const href = `${adminEndpoint}/service_cards_editor?district=${this.state.selected_district}&serviceType=${this.props.eservices[item].shortName}`
              return <Col key={i} xs={12} sm={6} md={4}><PaperTile href={`${href}`} text={this.props.eservices[item].title} epuap={this.props.eservices[item].requiresEPUAP} disabled={this.props.eservices[item].disabled}/></Col>;
            }
          },
          ) : null}
        {this.state.editMode === 'default' && this.state.all_services ? this.state.all_services.map(
          (item, i) => {
            if (this.props.eservices[item.value].title.toLowerCase().includes(this.state.service_filter_text.toLowerCase())) {
              const href = `${adminEndpoint}/service_cards_editor?district=default&serviceType=${this.props.eservices[item.value].shortName}`
              return <Col key={i} xs={12} sm={6} md={4}><PaperTile href={`${href}`} text={this.props.eservices[item.value].title} epuap={this.props.eservices[item.value].requiresEPUAP} disabled={this.props.eservices[item.value].disabled}/></Col>;
            }
          },
        ) : null}
      </div>
    );
  }

  render() {
    return (
      <Grid>
        <PaperHeader title="Zarządzanie kartami eusług" />
        {this.props.user && this.props.user.roles && this.props.user.roles.indexOf(adminRole) >= 0 ?
          <Row>
            <Col xs={6}>
              <button
                type="button"
                className={'btn btn-primary'}
                style={btnStyle}
                onClick={() => this.editModeChange('district')}
              >
                Edycja kart dla wybranego Urzędu
              </button>
            </Col>
            <Col xs={6}>
              <button
                type="button"
                className={'btn btn-primary'}
                style={btnStyle}
                onClick={() => this.editModeChange('default')}
              >
                Edycja kart domyślnych
              </button>
            </Col>

          </Row> : null}
        <br />

        {!this.props.isDistrictAdmin && this.state.editMode === 'district' ?
          <div className={'well well-sm'} style={{ background: this.state.style.backgroundColor }}>
            <h4 style={{ textAlign: 'center' }}>
              <b>Gminy:</b>
            </h4>
            <input
              type="text"
              className="form-control"
              style={{ width: '100%', position: 'relative', margin: '25px 0px 15px 0px' }}
              value={this.state.filter_text}
              placeholder="Wyszukaj urząd..."
              onChange={(e) => this.districtFilterChange(e)}
            />
            <ul className={'nav flex-column'} style={{ height: '400px', overflowY: 'scroll' }}>
              {this.props.districts && Object.keys(this.props.districts).sort()
                .filter(item => this.props.districts[item].name.toLowerCase().includes(this.state.filter_text.toLowerCase()))
                .map(item => (

                  <li className={'nav-item'} key={item}>
                    <button
                      type="button"
                      className={'btn btn-primary'}
                      style={btnStyle}
                      onClick={() => this.onClick(item)}
                    >
                      {this.props.districts[item].name}
                    </button>
                  </li>
                ))}
            </ul>
          </div> : null}
        {this.state.selected_district ?
          <h4
            style={{ textAlign: 'center' }}
          >
            <b>{this.props.districts[this.state.selected_district].name}</b>
          </h4> : null}
        <PaperHeader title="E-usługi" text="" />

        <Row>
          <input
            type="text"
            className="form-control"
            style={{ width: '60%', left: '20%', position: 'relative', margin: '25px 0px 15px 0px' }}
            value={this.state.service_filter_text}
            placeholder="Wyszukaj usługę..."
            onChange={(e) => this.serviceFilterChange(e)}
          />
          {this.renderPaperTiles()}
        </Row>


      </Grid>
    );
  }
}

const mapState = (state) => ({
  districts: state.district.districts,
  eservices: state.district.eservices,
});

const mapDispatch = {
  fetchDistrictServices,
};

export default withStyles(s)(connect(mapState, mapDispatch)(ServiceCards));



// WEBPACK FOOTER //
// src/routes/admin/service_cards/ServiceCards.js